export default __webpack_public_path__ + "static/media/logo.2e9f5a73.png";